import React, { useEffect, useState } from 'react'
import ConfirmExitModal from '@components/Modal/ConfirmExitModal/index'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
	fetchPackageServicesNoPagination,
	fetchItemsSelect,
} from '@utils/fetchData'
import { useQuery } from '@tanstack/react-query'
import {
	calculateTotalWithKoef,
	calculateLineTotal,
	calculateMetrTotalWithKoef,
} from '@utils/calculations'
import {
	formatInputNumber,
	formatNumberWithSpaces,
	numberWithSpacesIntl,
	removeSpaces,
} from '@utils/numberWithSpaces'
import { http } from '@services/http'
import { generateImage } from '@utils/generateShapeImage'
import {
	Checkbox,
	Modal,
	Space,
	Table,
	Button,
	Input,
	message,
	Radio,
} from 'antd'
import renderServiceTypeSvg from '@utils/renderServiceTypeSvg'
import {
	calculateShtPrices,
	calculateMetrPriceServices,
	calculateMetrPriceParametr,
	circleServiceQuantity,
	circleShapeQuantity,
	semiCircleShapeQuantity,
	shapeSidesQuantity,
} from '@utils/salesOrderCalculations'

export default function ServicesModal({
	visible,
	onClose,
	tableData,
	selectedData,
	setTableData,
	selectedRowIndex,
}) {
	const navigate = useNavigate()
	const { t } = useTranslation()

	const [activeTab, setActiveTab] = useState('tab1')
	const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false)
	const [isConfirmServiceModalVisible, setIsConfirmServiceModalVisible] =
		useState(false)
	const [selectedServices, setSelectedServices] = useState([])
	const [inputValues, setInputValues] = useState({})
	const [inputParametrQuantity, setInputParametrQuantity] = useState({})

	const biggestLineNum = Math.max(
		...tableData.flatMap((row) => [
			row.lineNum,
			...(row.selectedServices?.map((service) => service.lineNum) || []),
		]),
		0,
	)

	console.log('biggestLineNum', biggestLineNum)

	useEffect(() => {
		if (visible) {
			const mappedServices = selectedData.map((item) => ({
				...item,
				u_ShapeSidesArray: item?.u_ShapeSides
					? item.u_ShapeSides
							.split(';')
							.map((val) => ({ value: val.trim() }))
					: [{ value: '' }],
			}))
			console.log('mappedServices', mappedServices, selectedData)
			setSelectedServices(mappedServices)
		}
	}, [visible, selectedData])

	const fetchItemsSelect = async ({ queryKey }) => {
		const [_, itemName, category, api] = queryKey
		try {
			let url = `${api}?itemName=${itemName}&category=${category}&pageToken=0&pageSize=1000`
			const { data } = await http.get(url)

			const formattedData = data.data.map((item) => ({
				...item,
				image: generateImage(item.itemCode),
			}))
			return formattedData
		} catch (error) {
			console.log(error)
		}
	}

	const fetchRombikItems = async () => {
		try {
			let url = `api/items/items-and-price-of-shapes?TabType=Rombik&PageSize=1000&Skip=0&ModalService=Rhombic_Figures`
			const { data } = await http.get(url)

			const formattedData = data.map((item) => ({
				...item,
				image: generateImage(item.itemCode),
			}))
			return formattedData
		} catch (error) {
			console.log(error)
		}
	}

	const fetchKalitShapes = async () => {
		try {
			let url = `api/items/items-and-price-of-shapes?TabType=Kalit&PageSize=1000&Skip=0&ModalService=Key_Figures`
			const { data } = await http.get(url)

			const formattedData = data.map((item) => ({
				...item,
				image: generateImage(item.itemCode),
			}))
			return formattedData
		} catch (error) {
			console.log(error)
		}
	}

	const fetchTelefonItems = async () => {
		try {
			let url = `api/items/items-and-price-of-shapes?PageSize=1000&Skip=0&ModalService=Telefon`
			const { data } = await http.get(url)

			const formattedData = data.map((item) => ({
				...item,
				image: generateImage(item.itemCode),
			}))
			return formattedData
		} catch (error) {
			console.log(error)
		}
	}

	const { data: packageServicesData = [] } = useQuery({
		queryKey: ['packageServices'],
		queryFn: fetchPackageServicesNoPagination,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const { data: telefonItemsData = [] } = useQuery({
		queryKey: ['telefonItems'],
		queryFn: fetchTelefonItems,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		refetchInterval: 60000,
	})

	const { data: serviceItemsData = [] } = useQuery({
		// Bu toggleServicesCombinedni ichida ishlatilgan bu hamma uslugalarni olib keladi modalServicega bolmasdan
		queryKey: ['serviceItems', '', '', 'api/items/get-items'],
		queryFn: fetchItemsSelect,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		refetchInterval: 60000,
	})

	const { data: rombikItemsData = [] } = useQuery({
		queryKey: ['rombikItems'],
		queryFn: fetchRombikItems,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		refetchInterval: 60000,
	})

	const { data: kalitShapedData = [] } = useQuery({
		queryKey: ['kalitShapes'],
		queryFn: fetchKalitShapes,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		refetchInterval: 60000,
	})

	// const columnsServices = [
	// 	{
	// 		title: t('service'),
	// 		dataIndex: 'itemName',
	// 		key: 'itemName',
	// 		render: (text, record) => (
	// 			<span>
	// 				<span className="font-bold">
	// 					{record.u_Number ? `${record.u_Number} ` : ''}
	// 				</span>
	// 				{`${text}`}
	// 			</span>
	// 		),
	// 	},
	// 	{
	// 		title: t('price'),
	// 		dataIndex: 'price',
	// 		key: 'price',
	// 		render: (text) => (
	// 			<span>{text !== null ? numberWithSpacesIntl(text) : ''}</span>
	// 		),
	// 	},
	// 	{
	// 		title: t('measureUnit'),
	// 		dataIndex: 'ugpName',
	// 		key: 'ugpName',
	// 		render: (text) => <span>{text !== null ? text : ''}</span>,
	// 	},
	// {
	// 	title: t('quantity'),
	// 	dataIndex: 'quantity',
	// 	key: 'quantity',
	// 	width: 150,
	// 	render: (_, record) =>
	// 		record.ugpName === 'шт' ? (
	// 			<Input
	// 				value={
	// 					selectedServices.find(
	// 						(service) =>
	// 							service.itemCode === record.itemCode,
	// 					)?.quantity || ''
	// 				}
	// 				className={'w-full'}
	// 				disabled={
	// 					!selectedServices.some(
	// 						(service) =>
	// 							service.itemCode === record.itemCode,
	// 					)
	// 				}
	// 				onChange={(e) => {
	// 					const inputQuantity = e.target.value

	// 					// Update only the service that matches the record's itemCode
	// 					const updatedSelectedServices =
	// 						selectedServices.map((service) =>
	// 							service.itemCode === record.itemCode
	// 								? {
	// 										...service,
	// 										quantity: inputQuantity,
	// 										u_ShapeSidesArray: [
	// 											{ value: '' },
	// 										],
	// 									}
	// 								: service,
	// 						)

	// 					console.log(
	// 						'updatedSelectedServicesInServiceModal',
	// 						updatedSelectedServices,
	// 						inputQuantity,
	// 					)
	// 					setSelectedServices(updatedSelectedServices)

	// 					// const updatedData = tableData.map((row, index) => {
	// 					// 	if (index == selectedRowIndex) {
	// 					// 		const selectedServicesTotal =
	// 					// 			updatedSelectedServices.reduce(
	// 					// 				(acc, service) =>
	// 					// 					acc +
	// 					// 					service.price *
	// 					// 						(service.quantity || 0),
	// 					// 				0,
	// 					// 			)
	// 					// 		const koef = 1
	// 					// 		const totalWithKoef =
	// 					// 			calculateTotalWithKoef(
	// 					// 				row.width,
	// 					// 				row.height,
	// 					// 				inputQuantity,
	// 					// 				koef,
	// 					// 			)
	// 					// 		const lineTotal = calculateLineTotal(
	// 					// 			row.price,
	// 					// 			selectedServicesTotal,
	// 					// 			totalWithKoef,
	// 					// 		)

	// 					// 		return {
	// 					// 			...row,
	// 					// 			quantity: inputQuantity,
	// 					// 			lineTotal,
	// 					// 		}
	// 					// 	}
	// 					// 	return row
	// 					// })

	// 					// setTableData(updatedData)
	// 				}}
	// 				onClick={(e) => {
	// 					e.stopPropagation()
	// 				}}
	// 			/>
	// 		) : (
	// 			''
	// 		),
	// },
	// 	{
	// 		title: t('Select'),
	// 		dataIndex: 'itemCode',
	// 		key: 'select',
	// 		render: (itemCode, record) => {
	// 			const isChecked = selectedServices.some(
	// 				(service) => service.itemCode === itemCode,
	// 			)
	// 			return (
	// 				<Checkbox
	// 					checked={isChecked}
	// 					onChange={(e) => {
	// 						toggleServiceSelection(record.itemCode)
	// 					}}
	// 					onClick={(e) => {
	// 						e.stopPropagation()
	// 					}}
	// 				/>
	// 			)
	// 		},
	// 	},
	// ]

	// const columnsParametrs = [
	// 	{
	// 		title: t('service'),
	// 		dataIndex: 'image',
	// 		key: 'image',
	// 		render: (text, record) => (
	// 			<div className="flex flex-col items-center gap-2">
	// 				<img
	// 					src={record.image}
	// 					alt="service"
	// 					style={{ width: '50px', height: '50px' }}
	// 				/>
	// 				{/* <span>{record.itemCode}</span> */}
	// 				<span>
	// 					{record.itemCode === 'Circle' ||
	// 					record.itemCode === 'SemiCircle'
	// 						? t('mm')
	// 						: t('mm')}
	// 				</span>
	// 			</div>
	// 		),
	// 	},
	// 	{
	// 		title: t('itemName'),
	// 		dataIndex: 'itemName',
	// 		key: 'itemName',
	// 	},
	// 	{
	// 		title: t('price'),
	// 		dataIndex: 'price',
	// 		key: 'price',
	// 		render: (text) => (
	// 			<span>{text !== null ? formatNumberWithSpaces(text) : ''}</span>
	// 		),
	// 	},
	// {
	// 	title: t('size'),
	// 	dataIndex: 'itemCode',
	// 	key: 'inputs',
	// 	render: (itemCode, record, rowIndex) => {
	// const isSelected = selectedServices.some(
	// 	(service) => service.itemCode === record.itemCode,
	// )
	// const shapesArray = selectedServices.find(
	// 	(service) => service.itemCode === record.itemCode,
	// )?.u_ShapeSidesArray

	// const selectedServicesIndex = selectedServices.findIndex(
	// 	(service) => service.itemCode === record.itemCode,
	// )

	// return (
	// 	<div>
	// 		{renderInputs(
	// 			itemCode,
	// 			selectedServicesIndex,
	// 			isSelected,
	// 			shapesArray,
	// 		)}
	// 	</div>
	// )
	// 	},
	// },
	// {
	// 	title: t('quantity'),
	// 	dataIndex: 'itemCode',
	// 	key: 'inputs',
	// 	render: (itemCode, record, rowIndex) => {
	// 		const isSelected = selectedServices.some(
	// 			(service) => service.itemCode === record.itemCode,
	// 		)
	// 		const u_FigureQuantity = selectedServices.find(
	// 			(service) => service.itemCode === record.itemCode,
	// 		)?.u_FigureQuantity

	// 		const selectedServiceIndex = selectedServices.findIndex(
	// 			(service) => service.itemCode === record.itemCode,
	// 		)

	// 		return (
	// 			<div>
	// 				<Input
	// 					value={u_FigureQuantity}
	// 					onChange={(e) => {
	// 						console.log('e.target.value', e.target.value)
	// 						handleParametrQuantityInputChange(
	// 							selectedServiceIndex,
	// 							e.target.value,
	// 						)
	// 					}}
	// 					onClick={(e) => {
	// 						e.stopPropagation()
	// 					}}
	// 					className="mb-2 w-[100px]"
	// 					disabled={!isSelected}
	// 				/>
	// 			</div>
	// 		)
	// 	},
	// },

	// 	{
	// 		title: t('Select'),
	// 		dataIndex: 'itemCode',
	// 		key: 'select',
	// 		render: (itemCode, record) => (
	// 			<Checkbox
	// 				checked={selectedServices.some(
	// 					(service) => service.itemCode === itemCode,
	// 				)}
	// 				onChange={(e) => {
	// 					toggleParametrSelection(itemCode, record.key)
	// 				}}
	// 				onClick={(e) => {
	// 					e.stopPropagation()
	// 				}}
	// 			/>
	// 		),
	// 	},
	// ]

	// const columnsItemsImages = [
	// 	{
	// 		title: t('chizma'),
	// 		dataIndex: 'image',
	// 		key: 'image',
	// 		render: (text, record) => (
	// 			<div className="flex flex-col items-center gap-2">
	// 				<img
	// 					src={record.image}
	// 					alt="service"
	// 					style={{ width: '50px', height: '50px' }}
	// 				/>
	// 				<span>{record.itemName}</span>
	// 			</div>
	// 		),
	// 	},

	// 	{
	// 		title: t('Select'),
	// 		dataIndex: 'itemCode',
	// 		key: 'select',
	// 		width: 150,
	// 		render: (itemCode, record) => (
	// 			<div className="text-center">
	// 				<Checkbox
	// 					checked={selectedServices.some(
	// 						(service) => service.itemCode === itemCode,
	// 					)}
	// 					onChange={(e) => {
	// 						toggleItemsImagesSelection(itemCode)
	// 					}}
	// 					onClick={(e) => {
	// 						e.stopPropagation()
	// 					}}
	// 				/>
	// 			</div>
	// 		),
	// 	},
	// ]

	const columnsServices = [
		{
			title: t('svg'),
			dataIndex: 'svg',
			key: 'svg',

			render: (_, record) => {
				return renderServiceTypeSvg(record.u_ServiceType)
			},
		},
		{
			title: t('service'),
			dataIndex: 'itemName',
			key: 'itemName',
			render: (text, record) => (
				<span>
					<span className="font-bold">
						{record.u_Number ? `${record.u_Number} ` : ''}
					</span>
					{`${text}`}
				</span>
			),
		},

		{
			title: t('price'),
			dataIndex: 'price',
			key: 'price',
			render: (text) => (
				<span>{text !== null ? numberWithSpacesIntl(text) : ''}</span>
			),
		},
		{
			title: t('measureUnit'),
			dataIndex: 'ugpName',
			key: 'ugpName',
			render: (text, record) => (
				<span>
					{' '}
					{text !== null
						? record.itemName.includes('GRAVIROVKA')
							? 'м'
							: text
						: ''}
				</span>
			),
		},
		{
			title: t('quantity'),
			dataIndex: 'quantity',
			key: 'quantity',
			width: 150,
			render: (_, record) =>
				record.ugpName === 'шт' ? (
					<Input
						value={
							selectedServices.find(
								(service) =>
									service.itemCode === record.itemCode,
							)?.u_FigureQuantity || ''
						}
						className={'w-full'}
						disabled={
							!selectedServices.some(
								(service) =>
									service.itemCode === record.itemCode,
							)
						}
						onChange={(e) => {
							const inputQuantity = e.target.value

							// Update only the service that matches the record's itemCode
							const updatedSelectedServices =
								selectedServices.map((service) =>
									service.itemCode === record.itemCode
										? {
												...service,
												u_FigureQuantity: inputQuantity,
												u_ShapeSidesArray: [
													{ value: '' },
												],
											}
										: service,
								)

							console.log(
								'updatedSelectedServicesInServiceModal',
								updatedSelectedServices,
								inputQuantity,
							)
							setSelectedServices(updatedSelectedServices)

							// const updatedData = tableData.map((row, index) => {
							// 	if (index == selectedRowIndex) {
							// 		const selectedServicesTotal =
							// 			updatedSelectedServices.reduce(
							// 				(acc, service) =>
							// 					acc +
							// 					service.price *
							// 						(service.quantity || 0),
							// 				0,
							// 			)
							// 		const koef = 1
							// 		const totalWithKoef =
							// 			calculateTotalWithKoef(
							// 				row.width,
							// 				row.height,
							// 				inputQuantity,
							// 				koef,
							// 			)
							// 		const lineTotal = calculateLineTotal(
							// 			row.price,
							// 			selectedServicesTotal,
							// 			totalWithKoef,
							// 		)

							// 		return {
							// 			...row,
							// 			quantity: inputQuantity,
							// 			lineTotal,
							// 		}
							// 	}
							// 	return row
							// })

							// setTableData(updatedData)
						}}
						onClick={(e) => {
							e.stopPropagation()
						}}
					/>
				) : (
					''
				),
		},
		{
			title: t('Select'),
			dataIndex: 'itemCode',
			key: 'select',
			render: (itemCode, record) => {
				const isChecked = selectedServices.some(
					(service) => service.itemCode === itemCode,
				)
				return (
					<Checkbox
						checked={isChecked}
						onChange={(e) => {
							toggleServiceSelection(record.itemCode)
						}}
						disabled
						onClick={(e) => {
							e.stopPropagation()
						}}
					/>
				)
			},
		},
	]
	const columnsOtgruzka = [
		{
			title: t('service'),
			dataIndex: 'itemName',
			key: 'itemName',
			render: (text, record) => (
				<span>
					<span className="font-bold">
						{record.u_Number ? `${record.u_Number} ` : ''}
					</span>
					{`${text}`}
				</span>
			),
		},

		{
			title: t('price'),
			dataIndex: 'price',
			key: 'price',
			// render: (text) => (
			// 	<span>{text !== null ? numberWithSpacesIntl(text) : ''}</span>
			// ),
			render: (text, record) => (
				<Input
					value={
						formatInputNumber(
							selectedServices.find(
								(service) =>
									service.itemCode === record.itemCode,
							)?.price,
						) || ''
					}
					className={'w-full'}
					disabled={
						!selectedServices.some(
							(service) => service.itemCode === record.itemCode,
						)
					}
					onChange={(e) => {
						const inputQuantity = removeSpaces(e.target.value)

						// Update only the service that matches the record's itemCode
						const updatedSelectedServices = selectedServices.map(
							(service) =>
								service.itemCode === record.itemCode
									? {
											...service,
											price: inputQuantity,
										}
									: service,
						)
						setSelectedServices(updatedSelectedServices)
					}}
					onClick={(e) => {
						e.stopPropagation()
					}}
				/>
			),
		},

		{
			title: t('Select'),
			dataIndex: 'itemCode',
			key: 'select',
			render: (itemCode, record) => {
				const isChecked = selectedServices.some(
					(service) => service.itemCode === itemCode,
				)
				return (
					<Checkbox
						checked={isChecked}
						onChange={(e) => {
							toggleServiceSelection(record.itemCode)
						}}
						disabled={true}
						onClick={(e) => {
							e.stopPropagation()
						}}
					/>
				)
			},
		},
	]

	const columnsTelefonParametrs = [
		{
			title: t('service'),
			dataIndex: 'image',
			key: 'image',
			render: (text, record) => (
				<div className="flex flex-col items-center gap-2">
					<img
						src={record.image}
						alt="service"
						style={{ width: '50px', height: '50px' }}
					/>
					{/* <span>{record.itemCode}</span> */}
					<span>
						{record.itemCode === 'Circle' ||
						record.itemCode === 'SemiCircle'
							? t('mm')
							: t('mm')}
					</span>
				</div>
			),
		},

		{
			title: t('itemName'),
			dataIndex: 'itemName',
			key: 'itemName',
		},
		{
			title: t('typeOfGrinding'),
			dataIndex: 'serviceType',
			key: 'serviceType',
			render: (text, record, index) => (
				<Radio.Group
					value={
						selectedServices.find(
							(service) => service.itemCode === record.itemCode,
						)?.u_SharepeningType || ''
					}
					className="flex flex-col gap-3 min-w-[140px]"
					disabled={
						!selectedServices.some(
							(service) => service.itemCode === record.itemCode,
						)
					}
				>
					{record.priceLines
						?.map((item) => ({
							value: item.u_ServiceType,
							label: item.u_ServiceType,
							data: item,
						}))
						?.map((opt) => (
							<Radio
								key={opt.value}
								value={opt.value}
								onClick={(e, opt) => {
									e.stopPropagation()
								}}
								disabled
								onChange={(e, opt) => {
									const index = selectedServices.findIndex(
										(service) =>
											service.itemCode ===
											record.itemCode,
									)

									const selectedPriceLine =
										record.priceLines.find(
											(service) =>
												service.u_ServiceType ===
												e.target.value,
										)
									console.log(
										'selectedPriceLine',
										selectedPriceLine,
									)

									const updatedServices = [
										...selectedServices,
									]
									updatedServices[index] = {
										...updatedServices[index],
										u_SharepeningType: e.target.value,
										price: selectedPriceLine?.u_Price,
									}
									setSelectedServices(updatedServices)
								}}
							>
								{opt.label}
							</Radio>
						))}
				</Radio.Group>
			),
		},
		{
			title: t('price'),
			dataIndex: 'price',
			key: 'price',
			render: (text, record) => {
				const parametrsInfo = selectedServices.find(
					(service) => service.itemCode === record.itemCode,
				)

				// console.log('parametrsInfo', parametrsInfo)

				return (
					<span>
						{parametrsInfo?.price
							? formatNumberWithSpaces(parametrsInfo.price)
							: ''}
					</span>
				)
			},
		},

		{
			title: t('quantity'),
			dataIndex: 'quantity',
			key: 'quantity',
			render: (itemCode, record) => {
				const quantity = selectedServices.find(
					(service) => service.itemCode === record.itemCode,
				)?.u_FigureQuantity
				return (
					<span>
						{quantity ? formatNumberWithSpaces(quantity) : ''}
					</span>
				)
			},
		},

		{
			title: t('Select'),
			dataIndex: 'itemCode',
			key: 'select',
			render: (itemCode, record) => (
				<Checkbox
					checked={selectedServices.some(
						(service) => service.itemCode === itemCode,
					)}
					onChange={(e) => {
						toggleTelefonParametrSelection(itemCode, record.key)
					}}
					onClick={(e) => {
						e.stopPropagation()
					}}
					disabled
				/>
			),
		},
	]

	const columnsKalitParametrs = [
		{
			title: t('service'),
			dataIndex: 'image',
			key: 'image',
			render: (text, record) => (
				<div className="flex flex-col items-center gap-2">
					<img
						src={record.image}
						alt="service"
						style={{ width: '50px', height: '50px' }}
					/>
					{/* <span>{record.itemCode}</span> */}
					<span>
						{record.itemCode === 'Circle' ||
						record.itemCode === 'SemiCircle'
							? t('mm')
							: t('mm')}
					</span>
				</div>
			),
		},
		{
			title: t('itemName'),
			dataIndex: 'itemName',
			key: 'itemName',
		},
		{
			title: t('sizeType'),
			dataIndex: 'sizeType',
			key: 'sizeType',
			render: (text, record, index) => (
				<Radio.Group
					value={
						selectedServices.find(
							(service) => service.itemCode === record.itemCode,
						)?.u_SizeType || ''
					}
					className="flex flex-col gap-3 min-w-[140px]"
					disabled={
						!selectedServices.some(
							(service) => service.itemCode === record.itemCode,
						)
					}
				>
					{record.priceLines
						?.map((item) => ({
							value: item.u_SizeType,
							label: item.u_SizeType,
							data: item,
						}))
						?.map((opt) => (
							<Radio
								key={opt.value}
								value={opt.value}
								onClick={(e, opt) => {
									e.stopPropagation()
								}}
								onChange={(e, opt) => {
									const index = selectedServices.findIndex(
										(service) =>
											service.itemCode ===
											record.itemCode,
									)

									const selectedPriceLine =
										record.priceLines.find(
											(service) =>
												service.u_SizeType ===
												e.target.value,
										)

									const updatedServices = [
										...selectedServices,
									]
									updatedServices[index] = {
										...updatedServices[index],
										u_SizeType: e.target.value,
										price: selectedPriceLine?.u_Price,
									}
									setSelectedServices(updatedServices)
								}}
							>
								{opt.label}
							</Radio>
						))}
				</Radio.Group>
			),
		},
		{
			title: t('price'),
			dataIndex: 'price',
			key: 'price',
			render: (text, record) => {
				const parametrsInfo = selectedServices.find(
					(service) => service.itemCode === record.itemCode,
				)

				// console.log('parametrsInfo', parametrsInfo)

				return (
					<span>
						{parametrsInfo?.price
							? formatNumberWithSpaces(parametrsInfo.price)
							: ''}
					</span>
				)
			},
		},
		// {
		// 	title: t('size'),
		// 	dataIndex: 'itemCode',
		// 	key: 'inputs',
		// 	render: (itemCode, record) => {
		// 		const isSelected = selectedServices.some(
		// 			(service) => service.itemCode === record.itemCode,
		// 		)
		// 		return (
		// 			<div>
		// 				{renderInputs(
		// 					itemCode,
		// 					`${currentRecord.key}${itemCode}`,
		// 					isSelected,
		// 				)}
		// 			</div>
		// 		)
		// 	},
		// },
		{
			title: t('quantity'),
			dataIndex: 'itemCode',
			key: 'inputs',
			render: (itemCode, record, rowIndex) => {
				const isSelected = selectedServices.some(
					(service) => service.itemCode === record.itemCode,
				)
				const u_FigureQuantity = selectedServices.find(
					(service) => service.itemCode === record.itemCode,
				)?.u_FigureQuantity

				const selectedServiceIndex = selectedServices.findIndex(
					(service) => service.itemCode === record.itemCode,
				)

				return (
					<div>
						<Input
							value={u_FigureQuantity}
							onChange={(e) => {
								console.log('e.target.value', e.target.value)
								handleParametrQuantityInputChange(
									selectedServiceIndex,
									e.target.value,
								)
							}}
							onClick={(e) => {
								e.stopPropagation()
							}}
							className="mb-2 w-[100px]"
							disabled={!isSelected}
						/>
					</div>
				)
			},
		},

		{
			title: t('Select'),
			dataIndex: 'itemCode',
			key: 'select',
			render: (itemCode, record) => (
				<Checkbox
					checked={selectedServices.some(
						(service) => service.itemCode === itemCode,
					)}
					disabled
					onChange={(e) => {
						toggleKalitParametrSelection(itemCode, record.key)
					}}
					onClick={(e) => {
						e.stopPropagation()
					}}
				/>
			),
		},
	]

	const columnsRombikParametrs = [
		{
			title: t('service'),
			dataIndex: 'image',
			key: 'image',
			render: (text, record) => (
				<div className="flex flex-col items-center gap-2">
					<img
						src={record.image}
						alt="service"
						style={{ width: '50px', height: '50px' }}
					/>
					{/* <span>{record.itemCode}</span> */}
					<span>
						{record.itemCode === 'Circle' ||
						record.itemCode === 'SemiCircle'
							? t('mm')
							: t('mm')}
					</span>
				</div>
			),
		},

		{
			title: t('itemName'),
			dataIndex: 'itemName',
			key: 'itemName',
		},
		{
			title: t('typeOfGrinding'),
			dataIndex: 'serviceType',
			key: 'serviceType',
			render: (text, record, index) => (
				<Radio.Group
					value={
						selectedServices.find(
							(service) => service.itemCode === record.itemCode,
						)?.u_SharepeningType || ''
					}
					className="flex flex-col gap-3 min-w-[140px]"
					disabled={
						!selectedServices.some(
							(service) => service.itemCode === record.itemCode,
						)
					}
				>
					{record.priceLines
						?.map((item) => ({
							value: item.u_ServiceType,
							label: item.u_ServiceType,
							data: item,
						}))
						?.map((opt) => (
							<Radio
								key={opt.value}
								value={opt.value}
								onClick={(e, opt) => {
									e.stopPropagation()
								}}
								onChange={(e, opt) => {
									const index = selectedServices.findIndex(
										(service) =>
											service.itemCode ===
											record.itemCode,
									)

									const selectedPriceLine =
										record.priceLines.find(
											(service) =>
												service.u_ServiceType ===
												e.target.value,
										)
									console.log(
										'selectedPriceLine',
										selectedPriceLine,
									)

									const updatedServices = [
										...selectedServices,
									]
									updatedServices[index] = {
										...updatedServices[index],
										u_SharepeningType: e.target.value,
										price: selectedPriceLine?.u_Price,
									}
									setSelectedServices(updatedServices)
								}}
							>
								{opt.label}
							</Radio>
						))}
				</Radio.Group>
			),
		},
		{
			title: t('price'),
			dataIndex: 'price',
			key: 'price',
			render: (text, record) => {
				const parametrsInfo = selectedServices.find(
					(service) => service.itemCode === record.itemCode,
				)

				// console.log('parametrsInfo', parametrsInfo)

				return (
					<span>
						{parametrsInfo?.price
							? formatNumberWithSpaces(parametrsInfo.price)
							: ''}
					</span>
				)
			},
		},
		{
			title: t('size'),
			dataIndex: 'itemCode',
			key: 'inputsSize',
			render: (itemCode, record) => {
				const isSelected = selectedServices.some(
					(service) => service.itemCode === record.itemCode,
				)
				const shapesArray = selectedServices.find(
					(service) => service.itemCode === record.itemCode,
				)?.u_ShapeSidesArray

				const selectedServicesIndex = selectedServices.findIndex(
					(service) => service.itemCode === record.itemCode,
				)

				return (
					<div>
						{renderInputs(
							itemCode,
							selectedServicesIndex,
							isSelected,
							shapesArray,
						)}
					</div>
				)
			},
		},
		{
			title: t('quantity'),
			dataIndex: 'itemCode',
			key: 'inputs',
			render: (itemCode, record, rowIndex) => {
				const isSelected = selectedServices.some(
					(service) => service.itemCode === record.itemCode,
				)
				const u_FigureQuantity = selectedServices.find(
					(service) => service.itemCode === record.itemCode,
				)?.u_FigureQuantity

				const selectedServiceIndex = selectedServices.findIndex(
					(service) => service.itemCode === record.itemCode,
				)

				return (
					<div>
						<Input
							value={u_FigureQuantity}
							onChange={(e) => {
								console.log('e.target.value', e.target.value)
								handleParametrQuantityInputChange(
									selectedServiceIndex,
									e.target.value,
								)
							}}
							onClick={(e) => {
								e.stopPropagation()
							}}
							className="mb-2 w-[100px]"
							disabled={!isSelected}
						/>
					</div>
				)
			},
		},

		{
			title: t('Select'),
			dataIndex: 'itemCode',
			key: 'select',
			render: (itemCode, record) => (
				<Checkbox
					checked={selectedServices.some(
						(service) => service.itemCode === itemCode,
					)}
					disabled
					onChange={(e) => {
						toggleRombikParametrSelection(itemCode, record.key)
					}}
					onClick={(e) => {
						e.stopPropagation()
					}}
				/>
			),
		},
	]

	const columnsShablonParametrs = [
		{
			title: t('chizma'),
			dataIndex: 'image',
			key: 'image',
			render: (text, record) => (
				<div className="flex flex-col items-center gap-2">
					<img
						src={record.image}
						alt="service"
						style={{ width: '50px', height: '50px' }}
					/>
					<span>{record.itemName}</span>
				</div>
			),
		},

		{
			title: t('Select'),
			dataIndex: 'itemCode',
			key: 'select',
			width: 150,
			render: (itemCode, record) => (
				<div className="text-center">
					{/* Radio, not Checkbox: only one shablon figure can be chosen. */}
					<Radio
						checked={selectedServices.some(
							(service) => service.itemCode === itemCode,
						)}
						onChange={(e) => {
							toggleShablonParametrSelection(itemCode)
						}}
						disabled
						// disabled={selectedServices.every(
						// 	(service) => !service.isShablonService,
						// )}
						onClick={(e) => {
							e.stopPropagation()
						}}
					/>
				</div>
			),
		},
	]

	const columnsShablonServices = [
		{
			title: t('service'),
			dataIndex: 'itemName',
			key: 'itemName',
			render: (text, record) => (
				<span>
					<span className="font-bold">
						{record.u_Number ? `${record.u_Number} ` : ''}
					</span>
					{`${text}`}
				</span>
			),
		},
		{
			title: t('price'),
			dataIndex: 'price',
			key: 'price',
			render: (text) => (
				<span>{text !== null ? numberWithSpacesIntl(text) : ''}</span>
			),
		},
		{
			title: t('measureUnit'),
			dataIndex: 'ugpName',
			key: 'ugpName',
			render: (text) => <span>{text !== null ? text : ''}</span>,
		},
		{
			title: t('quantity'),
			dataIndex: 'u_FigureQuantity',
			key: 'u_FigureQuantity',
			width: 150,
			render: (_, record) => (
				// record.ugpName === 'шт' ? (
				<Input
					value={
						selectedServices.find(
							(service) => service.itemCode === record.itemCode,
						)?.u_FigureQuantity || ''
					}
					className={'w-full'}
					disabled={
						!selectedServices.some(
							(service) => service.itemCode === record.itemCode,
						)
					}
					onChange={(e) => {
						const inputQuantity = e.target.value

						// Update only the service that matches the record's itemCode
						const updatedSelectedServices = selectedServices.map(
							(service) =>
								service.itemCode === record.itemCode
									? {
											...service,
											u_FigureQuantity: inputQuantity,
											u_ShapeSidesArray: [{ value: '' }],
										}
									: service,
						)

						console.log(
							'updatedSelectedServicesInServiceModal',
							updatedSelectedServices,
							inputQuantity,
						)
						setSelectedServices(updatedSelectedServices)

						// const updatedData = tableData.map((row, index) => {
						// 	if (index == selectedRowIndex) {
						// 		const selectedServicesTotal =
						// 			updatedSelectedServices.reduce(
						// 				(acc, service) =>
						// 					acc +
						// 					service.price *
						// 						(service.quantity || 0),
						// 				0,
						// 			)
						// 		const koef = 1
						// 		const totalWithKoef =
						// 			calculateTotalWithKoef(
						// 				row.width,
						// 				row.height,
						// 				inputQuantity,
						// 				koef,
						// 			)
						// 		const lineTotal = calculateLineTotal(
						// 			row.price,
						// 			selectedServicesTotal,
						// 			totalWithKoef,
						// 		)

						// 		return {
						// 			...row,
						// 			quantity: inputQuantity,
						// 			lineTotal,
						// 		}
						// 	}
						// 	return row
						// })

						// setTableData(updatedData)
					}}
					onClick={(e) => {
						e.stopPropagation()
					}}
				/>
			),
			// ) : (
			// 	''
			// ),
		},
		{
			title: t('Select'),
			dataIndex: 'itemCode',
			key: 'select',
			render: (itemCode, record) => {
				const isChecked = selectedServices.some(
					(service) => service.itemCode === itemCode,
				)
				return (
					<Checkbox
						checked={isChecked}
						onChange={(e) => {
							toggleShablonServiceSelection(record.itemCode)
						}}
						disabled
						onClick={(e) => {
							e.stopPropagation()
						}}
					/>
				)
			},
		},
	]

	const columnsItemsImages = [
		{
			title: t('chizma'),
			dataIndex: 'image',
			key: 'image',
			render: (text, record) => (
				<div className="flex flex-col items-center gap-2">
					<img
						src={record.image}
						alt="service"
						style={{ width: '50px', height: '50px' }}
					/>
					<span>{record.itemName}</span>
				</div>
			),
		},

		{
			title: t('Select'),
			dataIndex: 'itemCode',
			key: 'select',
			width: 150,
			render: (itemCode, record) => (
				<div className="text-center">
					<Checkbox
						checked={selectedServices.some(
							(service) => service.itemCode === itemCode,
						)}
						disabled
						onChange={(e) => {
							toggleItemsImagesSelection(itemCode)
						}}
						onClick={(e) => {
							e.stopPropagation()
						}}
					/>
				</div>
			),
		},
	]

	const toggleTelefonParametrSelection = (itemCode, rowKey) => {
		const selectedService = telefonItemsData.find(
			(service) => service.itemCode === itemCode,
		)

		if (selectedService && currentRecord) {
			setSelectedServices((prevSelected) => {
				const isAlreadySelected = prevSelected.some(
					(service) => service.itemCode === itemCode,
				)

				let parametrQuantity

				if (itemCode === 'TelefonBurchak') {
					parametrQuantity = 1
				}

				if (itemCode === 'TelefonBurchak 2') {
					parametrQuantity = 3
				}

				if (itemCode === 'TelefonBurchak1') {
					parametrQuantity = 2
				}

				if (itemCode === 'TelefonBurchak3') {
					parametrQuantity = 4
				}

				let newSelectedServices

				if (isAlreadySelected) {
					newSelectedServices = prevSelected.filter(
						(service) => service.itemCode !== itemCode,
					)
				} else {
					const {
						itemCode,
						ugpName,
						u_Timer,
						u_Number,
						priceLines,
						u_Modal,
						u_ProductionNumber,
					} = selectedService
					const { lineNum, currency, quantity, width, height } =
						currentRecord
					newSelectedServices = [
						...prevSelected,
						{
							width,
							height,
							itemCode,
							price:
								priceLines.length > 0
									? priceLines[0].u_Price
									: -1,
							u_SharepeningType:
								priceLines.length > 0
									? priceLines[0].u_ServiceType
									: '',
							U_Elektr_rasxod:
								priceLines.length > 0
									? priceLines[0].U_Elektr_rasxod
									: -1,
							U_Stanok_rasxod:
								priceLines.length > 0
									? priceLines[0].U_Stanok_rasxod
									: -1,
							lineNum,
							currency,
							itemQuantity: quantity,
							u_ParametrQuantity: parametrQuantity,
							ugpName,
							u_Timer,
							u_Number,
							u_Modal,
							u_ProductionNumber,
						},
					]
				}
				return newSelectedServices
			})
		}
	}

	const toggleRombikParametrSelection = (itemCode, rowKey) => {
		const selectedService = rombikItemsData.find(
			(service) => service.itemCode === itemCode,
		)

		const inputCount = returnInputCountByItemCode(selectedService?.itemCode)

		if (selectedService && tableData[selectedRowIndex]) {
			setSelectedServices((prevSelected) => {
				const isAlreadySelected = prevSelected.some(
					(service) => service.itemCode === itemCode,
				)
				let newSelectedServices

				if (isAlreadySelected) {
					newSelectedServices = prevSelected.filter(
						(service) => service.itemCode !== itemCode,
					)
				} else {
					const {
						itemCode,
						ugpName,
						u_Timer,
						u_Number,
						priceLines,
						u_Modal,
					} = selectedService
					const { lineNum, currency, quantity, width, height } =
						tableData[selectedRowIndex]
					newSelectedServices = [
						...prevSelected,
						{
							width,
							height,
							itemCode,
							price:
								priceLines.length > 0
									? priceLines[0].u_Price
									: -1,
							u_SharepeningType:
								priceLines.length > 0
									? priceLines[0].u_ServiceType
									: '',
							U_Elektr_rasxod:
								priceLines.length > 0
									? priceLines[0].U_Elektr_rasxod
									: -1,
							U_Stanok_rasxod:
								priceLines.length > 0
									? priceLines[0].U_Stanok_rasxod
									: -1,
							lineNum: biggestLineNum + 1,
							currency,
							itemQuantity: quantity,
							u_PlannedQuantity: quantity,
							ugpName,
							u_Timer,
							u_Number,
							u_Modal,
							u_ShapeSidesArray: Array.from(
								{ length: inputCount },
								() => ({
									value: '',
								}),
							),
							isParametr: true,
							isRombikParametr: true,
						},
					]
				}
				return newSelectedServices
			})

			// setInputValues((prev) => {
			// 	const updatedValues = { ...prev }
			// 	if (!prev[rowKey]) {
			// 		updatedValues[rowKey] = Array(10).fill('')
			// 	}
			// 	if (
			// 		selectedServices.some(
			// 			(service) => service.itemCode === itemCode,
			// 		)
			// 	) {
			// 		return updatedValues[rowKey]
			// 	}
			// 	return updatedValues
			// })
		}
	}

	const toggleKalitParametrSelection = (itemCode, rowKey) => {
		const selectedService = kalitShapedData.find(
			(service) => service.itemCode === itemCode,
		)
		if (selectedService && tableData[selectedRowIndex]) {
			setSelectedServices((prevSelected) => {
				const isAlreadySelected = prevSelected.some(
					(service) => service.itemCode === itemCode,
				)
				let newSelectedServices

				if (isAlreadySelected) {
					newSelectedServices = prevSelected.filter(
						(service) => service.itemCode !== itemCode,
					)
				} else {
					const {
						itemCode,
						ugpName,
						u_Timer,
						u_Number,
						priceLines,
						u_Modal,
					} = selectedService
					const { lineNum, currency, quantity, width, height } =
						tableData[selectedRowIndex]
					newSelectedServices = [
						...prevSelected,
						{
							width,
							height,
							itemCode,
							price:
								priceLines.length > 0
									? priceLines[0].u_Price
									: -1,
							u_SizeType:
								priceLines.length > 0
									? priceLines[0].u_SizeType
									: '',
							U_Elektr_rasxod:
								priceLines.length > 0
									? priceLines[0].U_Elektr_rasxod
									: -1,
							U_Stanok_rasxod:
								priceLines.length > 0
									? priceLines[0].U_Stanok_rasxod
									: -1,
							lineNum: biggestLineNum + 1,
							currency,
							itemQuantity: quantity,
							u_PlannedQuantity: quantity,
							ugpName,
							u_Modal,
							u_Timer,
							u_Number,
							isParametr: true,
							isKalitParametr: true,
						},
					]
				}
				return newSelectedServices
			})

			// setInputValues((prev) => {
			// 	const updatedValues = { ...prev }
			// 	if (!prev[rowKey]) {
			// 		updatedValues[rowKey] = Array(10).fill('')
			// 	}
			// 	if (
			// 		selectedServices.some(
			// 			(service) => service.itemCode === itemCode,
			// 		)
			// 	) {
			// 		return updatedValues[rowKey]
			// 	}
			// 	return updatedValues
			// })
		}
	}

	const toggleServiceSelection = (itemCode) => {
		const selectedService = serviceItemsData.find(
			(service) => service.itemCode === itemCode,
		)
		if (selectedService && tableData[selectedRowIndex]) {
			setSelectedServices((prevSelected) => {
				const isAlreadySelected = prevSelected.some(
					(service) => service.itemCode === itemCode,
				)
				let newSelectedServices

				if (isAlreadySelected) {
					newSelectedServices = prevSelected.filter(
						(service) => service.itemCode !== itemCode,
					)
				} else {
					const {
						itemCode,
						price,
						ugpName,
						u_Timer,
						u_Number,
						u_ServiceType: uItemServiceType,
						u_Modal,
						U_Elektr_rasxod,
						U_Stanok_rasxod,
					} = selectedService
					const {
						lineNum,
						currency,
						quantity,
						width,
						height,
						u_PlannedQuantity,
					} = tableData[selectedRowIndex]
					newSelectedServices = [
						...prevSelected,
						{
							width,
							height,
							itemCode,
							price,
							lineNum: biggestLineNum + 1,
							currency,
							quantity,
							itemQuantity: quantity,
							u_PlannedQuantity,
							ugpName,
							u_Timer,
							u_Number,
							uItemServiceType,
							u_Modal,
							isParametr: false,
							isService: true,
							U_Elektr_rasxod,
							U_Stanok_rasxod,
						},
					]
				}
				return newSelectedServices
			})
		}
	}

	const toggleShablonServiceSelection = (itemCode) => {
		const selectedService = serviceItemsData.find(
			(service) => service.itemCode === itemCode,
		)

		if (selectedService && tableData[selectedRowIndex]) {
			setSelectedServices((prevSelected) => {
				const isAlreadySelected = prevSelected.some(
					(service) => service.itemCode === itemCode,
				)
				let newSelectedServices

				if (isAlreadySelected) {
					newSelectedServices = prevSelected.filter(
						(service) => service.itemCode !== itemCode,
					)
				} else {
					const {
						itemCode,
						price,
						ugpName,
						u_Timer,
						u_Number,
						u_Modal,
						U_Elektr_rasxod,
						U_Stanok_rasxod,
					} = selectedService
					const { lineNum, currency, quantity, width, height } =
						tableData[selectedRowIndex]
					newSelectedServices = [
						...prevSelected,
						{
							width,
							height,
							itemCode,
							price,
							lineNum: biggestLineNum + 1,
							currency,
							quantity,
							u_PlannedQuantity: quantity,
							itemQuantity: quantity,
							ugpName,
							u_Timer,
							u_Number,
							u_Modal,
							isParametr: false,
							isShablonService: true,
							isService: true,
							U_Elektr_rasxod,
							U_Stanok_rasxod,
						},
					]
				}
				return newSelectedServices
			})
		}
	}

	const toggleItemsImagesSelection = (itemCode) => {
		const selectedService = serviceItemsData.find(
			(service) => service.itemCode === itemCode,
		)
		if (selectedService && tableData[selectedRowIndex]) {
			setSelectedServices((prevSelected) => {
				const isAlreadySelected = prevSelected.some(
					(service) => service.itemCode === itemCode,
				)
				let newSelectedServices

				if (isAlreadySelected) {
					newSelectedServices = prevSelected.filter(
						(service) => service.itemCode !== itemCode,
					)
				} else {
					const {
						itemCode,
						price,
						ugpName,
						u_Timer,
						u_Number,
						u_Modal,
						U_Elektr_rasxod,
						U_Stanok_rasxod,
					} = selectedService
					const { lineNum, currency, quantity, width, height } =
						tableData[selectedRowIndex]
					newSelectedServices = [
						...prevSelected,
						{
							width: 0,
							height: 0,
							itemCode,
							price: 0,
							lineNum: biggestLineNum + 1,
							currency,
							quantity: 0,
							u_PlannedQuantity: 0,
							ugpName,
							u_Timer,
							u_Number,
							u_Modal,
							U_Elektr_rasxod,
							U_Stanok_rasxod,
							isParametr: false,
							isChizma: true,
						},
					]
				}
				return newSelectedServices
			})
		}
	}

	const toggleShablonParametrSelection = (itemCode) => {
		if (selectedServices.every((service) => !service.isShablonService)) {
			return message.error('Сначала Выберите шаблонную услугу')
		}
		const selectedService = serviceItemsData.find(
			(service) => service.itemCode === itemCode,
		)

		const isAlreadySelectedShablonParametr = selectedServices.some(
			(service) => service.isShablonParametr === true,
		)

		const isAlreadySelected = selectedServices.some(
			(service) => service.itemCode === itemCode,
		)

		if (selectedService && tableData[selectedRowIndex]) {
			setSelectedServices((prevSelected) => {
				let newSelectedServices

				if (isAlreadySelected) {
					newSelectedServices = prevSelected.filter(
						(service) => service.itemCode !== itemCode,
					)
				} else {
					const {
						itemCode,
						price,
						ugpName,
						u_Timer,
						u_Number,
						u_Modal,
						U_Elektr_rasxod,
						U_Stanok_rasxod,
					} = selectedService
					const { lineNum, currency, quantity, width, height } =
						tableData[selectedRowIndex]
					newSelectedServices = [
						// Only one shablon figure may be selected, so drop any
						// previously chosen one instead of appending to it.
						...prevSelected.filter(
							(service) => !service.isShablonParametr,
						),
						{
							width: 0,
							height: 0,
							itemCode,
							price: 0,
							lineNum: biggestLineNum + 1,
							currency,
							quantity: 0,
							u_PlannedQuantity: 0,
							ugpName,
							u_Timer,
							u_Number,
							u_Modal,
							U_Elektr_rasxod,
							U_Stanok_rasxod,
							isParametr: false,
							isChizma: false,
							isShablonParametr: true,
						},
					]
				}
				return newSelectedServices
			})
		}
	}

	const toggleServiceSelectionGroup = (line) => {
		const selectedService = line
			.map((item) =>
				serviceItemsData.find(
					(service) => service.itemCode === item.itemCode,
				),
			)
			.filter(Boolean) // Remove undefined values

		// Find itemCodes that do not exist
		const missingItemCodes = line
			.map((item) => item.itemCode)
			.filter(
				(itemCode) =>
					!serviceItemsData.some(
						(service) => service.itemCode === itemCode,
					),
			)

		// Show an error message for missing itemCodes
		if (missingItemCodes.length > 0) {
			message.error(
				`The following item codes were not found: ${missingItemCodes.join(', ')}`,
			)
		}

		if (selectedService.length > 0 && tableData[selectedRowIndex]) {
			setSelectedServices((prevSelected) => {
				const isAlreadySelected = line.every((item) =>
					prevSelected.some(
						(service) => service.itemCode === item.itemCode,
					),
				)

				let newSelectedServices

				if (isAlreadySelected) {
					newSelectedServices = prevSelected.filter(
						(service) =>
							!line.some(
								(item) => item.itemCode === service.itemCode,
							),
					)
				} else {
					const newServices = selectedService.map(
						({
							itemCode,
							price,
							ugpName,
							u_Timer,
							u_Number,
							u_Modal,
							U_Elektr_rasxod,
							U_Stanok_rasxod,
						}) => {
							const {
								lineNum,
								currency,
								quantity,
								width,
								height,
							} = tableData[selectedRowIndex]
							return {
								width,
								height,
								itemCode,
								price,
								lineNum: biggestLineNum + 1,
								currency,
								quantity,
								u_PlannedQuantity: quantity,
								ugpName,
								u_Modal,
								u_Timer,
								u_Number,
								U_Elektr_rasxod,
								U_Stanok_rasxod,
								isParametr: false,
								isService: true,
							}
						},
					)
					newSelectedServices = [...prevSelected, ...newServices]
				}
				return newSelectedServices
			})
		}
	}

	const handleOkCombined = () => {
		const updatedSelectedServices = selectedServices.map((service) => {
			let quantity = +service.quantity || 0
			let u_ParametrQuantityValues = service.u_FigureQuantity || 0
			let isParametr = false
			let u_ItemGroup = service.u_ItemGroup

			const inputValuesForRow = service?.u_ShapeSidesArray || []

			if (
				service.u_Modal === 'Circle_Services' &&
				service.ugpName === 'м'
			) {
				quantity = circleServiceQuantity(service.width, service.itemQuantity)
			}

			if (inputValuesForRow.length > 0 && inputValuesForRow[0]?.value) {
				if (service.itemCode === 'Circle') {
					const value = parseFloat(inputValuesForRow[0].value || 0)
					quantity = circleShapeQuantity(value)
					// isParametr = true
					u_ItemGroup = 'Shape'
				} else if (service.itemCode === 'SemiCircle') {
					const value = parseFloat(inputValuesForRow[0].value || 0)
					quantity = semiCircleShapeQuantity(value)
					// isParametr = true,
					u_ItemGroup = 'Shape'
				} else {
					quantity = shapeSidesQuantity(
						inputValuesForRow.map((v) => v?.value),
					)
					// isParametr = true,
					u_ItemGroup = 'Shape'
				}
			}

			const figureQuantity = service?.u_FigureQuantity

			// if (inputParametrQuantityValues.length > 0) {
			// 	u_ParametrQuantityValues = inputParametrQuantityValues.reduce(
			// 		(acc, val) => acc + parseFloat(val || 0),
			// 		0,
			// 	)
			// 	// isParametr = true,
			// 	u_ItemGroup = 'Shape'
			// }

			// Buyoda azgina logika ozgarishi mumkun yani 	service.itemQuantity bunga ham kopaytirish qoshilishi mumkun bu itemmi tashqaridigi tabledigi yozilgan soni ozi postda (+service.quantity * 	+service.u_ParametrQuantityValues * 	service.itemQuantity) bunda service.itemQuantity  ham qoshilgan ekan  ekan
			// Ozi bunda yozilgan O'lcham inputlarini jami bilan *  yozilgan input soniga kopaytilyapti hozir Figuri modaldigi
			const totalPemitr = quantity * (figureQuantity || 1)

			const u_ShapeSides = service?.u_ShapeSidesArray
				?.map((side) => side.value)
				.join(';')
			return {
				...service,
				quantity,
				// u_PlannedQuantity: serv quantity,
				u_ParametrQuantityValues: u_ParametrQuantityValues || 0,
				totalPemitr: totalPemitr,
				u_ShapeSides,
				isParametr:
					service.u_ItemGroup == 'Shape' ||
					service.u_Modal == 'Key_Figures'
						? true
						: false,
				isChizma: service.u_ItemGroup == 'Chizma' ? true : false,
			}
		})

		const selectedPrices = updatedSelectedServices.reduce(
			(acc, service) => {
				if (service.ugpName !== 'шт') {
					return acc + service.price
				}
				return acc
			},
			0,
		)

		const shtPrices = calculateShtPrices(updatedSelectedServices)

		//
		const totalPerimetr = updatedSelectedServices.reduce((acc, service) => {
			return acc + service.totalPemitr
		}, 0)

		const updatedData = tableData.map((row, index) => {
			if (index == selectedRowIndex) {
				const koef = 1
				const totalWithKoef = calculateTotalWithKoef(
					row.width,
					row.height,
					row.quantity,
					koef,
				)
				const mWithKoef = calculateMetrTotalWithKoef(
					row.width,
					row.height,
					row.quantity,
					koef,
				)

				const mPrices = updatedSelectedServices.reduce(
					(acc, service) => {
						if (service.ugpName === 'м') {
							return acc + service.price * mWithKoef
						}
						return acc
					},
					0,
				)

				const lineTotal =
					calculateLineTotal(
						row.price,
						selectedPrices,
						totalWithKoef,
					) +
					mPrices +
					shtPrices

				return {
					...row,
					selectedServices: updatedSelectedServices,
					lineTotal,
					totalPerimetr,
				}
			}
			return row
		})

		setTableData(updatedData)
		setSelectedServices(updatedSelectedServices)
		onClose()
	}

	const returnInputCountByItemCode = (itemCode) => {
		let inputCount = 1
		if (
			itemCode === 'Rectangle' ||
			itemCode === 'Parallelogram' ||
			itemCode === 'Square' ||
			itemCode === 'Asal02' ||
			itemCode === 'Rhombus' ||
			itemCode === 'Trapezoid' ||
			itemCode === 'Archa01' ||
			itemCode === 'Archa02' ||
			itemCode === 'Archa' ||
			itemCode === 'Rectangle02' ||
			itemCode === 'Trapezoid' ||
			itemCode === 'Parallelogram' ||
			itemCode === 'Archa'
		) {
			inputCount = 4
		} else if (
			itemCode === 'Qalam01' ||
			itemCode === 'Qalam02' ||
			itemCode === 'Pentagon' ||
			itemCode === 'Asal01'
		) {
			inputCount = 5
		} else if (itemCode === 'Triangle' || itemCode === 'Triangle01') {
			inputCount = 3
		} else if (itemCode === 'Octagon' || itemCode === 'Qombik') {
			inputCount = 8
		} else if (itemCode === 'Triangle02') {
			inputCount = 3
		} else if (
			itemCode === 'Pencil' ||
			itemCode === 'Qalam' ||
			itemCode === 'Qombik1' ||
			itemCode === 'Qombik2' ||
			itemCode === 'Asal'
		) {
			inputCount = 6
		} else if (
			itemCode === 'SemiCircle' ||
			itemCode === 'Oval' ||
			itemCode === 'Oval01' ||
			itemCode === 'Oval02' ||
			itemCode === 'Circle' ||
			itemCode === 'MabelShablon9' ||
			itemCode === 'MebelShablon10' ||
			itemCode === 'TelefonBurchak1'
		) {
			inputCount = 1
		} else if (itemCode !== 'Circle') {
			inputCount = 1
			//Qolgan shakllarga bitta input bo'ladi
		}
		return inputCount
	}

	// const handleOkCombined = () => {
	// 	console.log('selectedServices before', selectedServices)
	// 	const updatedSelectedServices = selectedServices.map((service) => {
	// 		let quantity = +service.quantity
	// 		let u_ParametrQuantityValues = service.u_FigureQuantity || 0
	// 		let isParametr = false
	// 		let u_ItemGroup = service.u_ItemGroup
	// 		// Calculate quantity for shapes if inputValues are present
	// 		// const inputValuesForRow =
	// 		// 	inputValues[`${selectedData?.key}${service.itemCode}`] || []

	// 		const inputValuesForRow = service?.u_ShapeSidesArray || []

	// 		if (inputValuesForRow.length > 0 && inputValuesForRow[0]?.value) {
	// 			if (service.itemCode === 'Circle') {
	// 				const value = parseFloat(inputValuesForRow[0].value || 0)
	// 				quantity = (3.14 * value) / 1000
	// 				// isParametr = true
	// 				u_ItemGroup = 'Shape'
	// 			} else if (service.itemCode === 'SemiCircle') {
	// 				const value = parseFloat(inputValuesForRow[0].value || 0)
	// 				quantity = (3.14 * (value / 2)) / 1000
	// 				// isParametr = true,
	// 				u_ItemGroup = 'Shape'
	// 			} else {
	// 				quantity =
	// 					inputValuesForRow.reduce(
	// 						(acc, val) => acc + parseFloat(val?.value || 0),
	// 						0,
	// 					) / 1000
	// 				// isParametr = true,
	// 				u_ItemGroup = 'Shape'
	// 			}
	// 		}

	// 		const figureQuantity = service?.u_FigureQuantity

	// 		// if (inputParametrQuantityValues.length > 0) {
	// 		// 	u_ParametrQuantityValues = inputParametrQuantityValues.reduce(
	// 		// 		(acc, val) => acc + parseFloat(val || 0),
	// 		// 		0,
	// 		// 	)
	// 		// 	// isParametr = true,
	// 		// 	u_ItemGroup = 'Shape'
	// 		// }

	// 		// Buyoda azgina logika ozgarishi mumkun yani 	service.itemQuantity bunga ham kopaytirish qoshilishi mumkun bu itemmi tashqaridigi tabledigi yozilgan soni ozi postda (+service.quantity * 	+service.u_ParametrQuantityValues * 	service.itemQuantity) bunda service.itemQuantity  ham qoshilgan ekan  ekan
	// 		// Ozi bunda yozilgan O'lcham inputlarini jami bilan *  yozilgan input soniga kopaytilyapti hozir Figuri modaldigi
	// 		const totalPemitr = quantity * figureQuantity

	// 		const u_ShapeSides = service?.u_ShapeSidesArray
	// 			?.map((side) => side.value)
	// 			.join(';')
	// 		return {
	// 			...service,
	// 			quantity,
	// 			u_ParametrQuantityValues: u_ParametrQuantityValues || 0,
	// 			totalPemitr: totalPemitr,
	// 			u_ShapeSides,
	// 			isParametr: service.u_ItemGroup == 'Shape' ? true : false,
	// 			isChizma: service.u_ItemGroup == 'Chizma' ? true : false,
	// 		}
	// 	})

	// 	// Calculate selectedPrices and shtPrices for services
	// 	const selectedPrices = updatedSelectedServices.reduce(
	// 		(acc, service) => {
	// 			if (service.ugpName !== 'шт') {
	// 				return acc + service.price
	// 			}
	// 			return acc
	// 		},
	// 		0,
	// 	)

	// 	const shtPrices = updatedSelectedServices.reduce((acc, service) => {
	// 		if (service.ugpName === 'шт') {
	// 			return acc + service.price * service.quantity
	// 		}
	// 		return acc
	// 	}, 0)

	// 	//
	// 	const totalPerimetr = updatedSelectedServices.reduce((acc, service) => {
	// 		return acc + service.totalPemitr
	// 	}, 0)

	// 	const updatedData = tableData.map((row, index) => {
	// 		if (index == selectedRowIndex) {
	// 			const koef = 1
	// 			const totalWithKoef = calculateTotalWithKoef(
	// 				row.width,
	// 				row.height,
	// 				row.quantity,
	// 				koef,
	// 			)
	// 			const mWithKoef = calculateMetrTotalWithKoef(
	// 				row.width,
	// 				row.height,
	// 				row.quantity,
	// 				koef,
	// 			)

	// 			const mPrices = updatedSelectedServices.reduce(
	// 				(acc, service) => {
	// 					if (service.ugpName === 'м') {
	// 						return acc + service.price * mWithKoef
	// 					}
	// 					return acc
	// 				},
	// 				0,
	// 			)

	// 			const lineTotal =
	// 				calculateLineTotal(
	// 					row.price,
	// 					selectedPrices,
	// 					totalWithKoef,
	// 				) +
	// 				mPrices +
	// 				shtPrices

	// 			return {
	// 				...row,
	// 				selectedServices: updatedSelectedServices,
	// 				lineTotal,
	// 				totalPerimetr,
	// 			}
	// 		}
	// 		return row
	// 	})

	// 	setTableData(updatedData)
	// 	setSelectedServices(updatedSelectedServices)
	// 	onClose()
	// }

	const handleParametrQuantityInputChange = (index, value) => {
		console.log('index', index, 'value', value, selectedServices[index])
		const updatedValues = [...selectedServices]
		updatedValues[index].u_FigureQuantity = value
		setSelectedServices(updatedValues)
	}

	const handleInputChange = (rowIndex, index, value) => {
		setSelectedServices((prev) => {
			const updated = [...prev]
			const service = { ...updated[rowIndex] }
			const sides = service.u_ShapeSidesArray
				? [...service.u_ShapeSidesArray]
				: []

			// Ensure the array has enough objects
			while (sides.length <= index) {
				sides.push({ value: '' })
			}

			sides[index] = { ...sides[index], value }
			service.u_ShapeSidesArray = sides
			updated[rowIndex] = service
			return updated
		})
	}

	const renderInputs = (itemCode, rowIndex, isSelected, shapeSides) => {
		let inputCount = returnInputCountByItemCode(itemCode)

		return Array.from({ length: inputCount }, (_, index) => (
			<Input
				// key={`${rowKey}-input-${index}`}
				value={
					(shapeSides &&
						shapeSides[index] &&
						shapeSides[index].value) ||
					''
				}
				onChange={(e) => {
					if (shapeSides) {
						handleInputChange(rowIndex, index, e.target.value)
					}
				}}
				onClick={(e) => {
					e.stopPropagation()
				}}
				className="mb-2 w-full"
				disabled={!isSelected}
			/>
		))
	}

	// const renderContent = () => {
	// 	switch (activeTab) {
	// 		case 'tab1':
	// 			return (
	// 				<>
	// 					<span className="font-bold text-lg">
	// 						{t('chooseServicesPackage')}
	// 					</span>
	// 					<div className="flex flex-col  gap-1 mt-4 mb-4">
	// 						{packageServicesData.map((service) => (
	// 							<div
	// 								key={service.code}
	// 								className="flex items-center gap-2"
	// 							>
	// 								<span
	// 									className="text-blue-600 hover:text-blue-800 cursor-pointer  font-bold"
	// 									onClick={() =>
	// 										toggleServiceSelectionGroup(
	// 											service.serviceLines,
	// 										)
	// 									}
	// 								>
	// 									{service.name}
	// 								</span>
	// 							</div>
	// 						))}
	// 					</div>
	// 					<Table
	// 						columns={columnsServices}
	// 						dataSource={xizmatlarServices}
	// 						rowKey={(record) => record.itemCode}
	// 						onRow={(record) => ({
	// 							onClick: (e) => {
	// 								e.stopPropagation()
	// 								toggleServiceSelection(record?.itemCode)
	// 							},
	// 						})}
	// 						pagination={false}
	// 					/>
	// 				</>
	// 			)
	// 		case 'tab2':
	// 			return (
	// 				<>
	// 					<span className="font-bold text-lg">
	// 						{t('chooseServicesPackage')}
	// 					</span>
	// 					<div className="flex flex-col  gap-1 mt-4 mb-4">
	// 						{packageServicesData.map((service) => (
	// 							<div
	// 								key={service.code}
	// 								className="flex items-center gap-2"
	// 							>
	// 								<span
	// 									className="text-blue-600 hover:text-blue-800 cursor-pointer  font-bold"
	// 									onClick={() =>
	// 										toggleServiceSelectionGroup(
	// 											service.serviceLines,
	// 										)
	// 									}
	// 								>
	// 									{service.name}
	// 								</span>
	// 							</div>
	// 						))}
	// 					</div>
	// 					<Table
	// 						columns={columnsServices}
	// 						dataSource={dumaloqServices}
	// 						rowKey={(record) => record.itemCode}
	// 						onRow={(record) => ({
	// 							onClick: (e) => {
	// 								e.stopPropagation()
	// 								toggleServiceSelection(record?.itemCode)
	// 							},
	// 						})}
	// 						pagination={false}
	// 					/>
	// 				</>
	// 			)

	// 		case 'tab3':
	// 			return (
	// 				<div className="mt-5 overflow-auto">
	// 					<Table
	// 						columns={columnsParametrs}
	// 						dataSource={geometricShapesData}
	// 						rowKey={(record) => record.itemCode}
	// 						onRow={(record) => ({
	// 							onClick: (e) => {
	// 								e.stopPropagation()
	// 								// toggleParametrSelection(
	// 								// 	record?.itemCode,
	// 								// 	record?.key,
	// 								// )
	// 							},
	// 						})}
	// 						pagination={false}
	// 					/>
	// 				</div>
	// 			)
	// 		case 'tab4':
	// 			return (
	// 				<div className="mt-5 overflow-auto">
	// 					<Table
	// 						columns={columnsItemsImages}
	// 						dataSource={itemsImagesData}
	// 						rowKey={(record) => record.itemCode}
	// 						onRow={(record) => ({
	// 							onClick: (e) => {
	// 								e.stopPropagation()
	// 								toggleItemsImagesSelection(record?.itemCode)
	// 							},
	// 						})}
	// 						pagination={false}
	// 					/>
	// 				</div>
	// 			)

	// 		default:
	// 			return null
	// 	}
	// }

	const renderContent = () => {
		switch (activeTab) {
			case 'tab1':
				return (
					<>
						{/* <span className="font-bold text-lg">
							{t('chooseServicesPackage')}
						</span>
						<div className="flex flex-col  gap-1 mt-4 mb-4">
							{packageServicesData.map((service) => (
								<div
									key={service.code}
									className="flex items-center gap-2"
								>
									<span
										className="text-blue-600 hover:text-blue-800 cursor-pointer  font-bold"
										onClick={() =>
											toggleServiceSelectionGroup(
												service.serviceLines,
											)
										}
									>
										{service.name}
									</span>
								</div>
							))}
						</div> */}
						<Table
							columns={columnsServices}
							dataSource={serviceItemsData?.filter(
								(item) => item.u_Modal === 'Key_Services',
							)}
							rowKey={(record) => record.itemCode}
							onRow={(record) => ({
								// onClick: (e) => {
								// 	e.stopPropagation()
								// 	toggleServiceSelection(record?.itemCode)
								// },
							})}
							pagination={false}
						/>
					</>
				)

			case 'tab2':
				return (
					<>
						<Table
							columns={columnsServices}
							dataSource={serviceItemsData?.filter(
								(item) => item.u_Modal === 'Circle_Services',
							)}
							rowKey={(record) => record.itemCode}
							onRow={(record) => ({
								// onClick: (e) => {
								// 	e.stopPropagation()
								// 	toggleServiceSelection(record?.itemCode)
								// },
							})}
							pagination={false}
						/>
						<div className="flex flex-col gap-2 mt-10">
							<span className="font-bold text-lg mb-5">
								{t('Telefon Burchak')}
							</span>
							<Table
								columns={columnsTelefonParametrs}
								dataSource={telefonItemsData?.sort((a, b) => {
									return a?.itemName.localeCompare(
										b?.itemName,
										'ru',
									)
								})}
								rowKey={(record) => record.itemCode}
								pagination={false}
							/>
						</div>
					</>
				)

			case 'tab3':
				return (
					<>
						<Table
							columns={columnsRombikParametrs}
							dataSource={rombikItemsData}
							rowKey={(record) => record.itemCode}
							onRow={(record) => ({
								// onClick: (e) => {
								// 	e.stopPropagation()
								// 	toggleRombikParametrSelection(
								// 		record?.itemCode,
								// 		record?.key,
								// 	)
								// },
							})}
							pagination={false}
						/>
					</>
				)

			case 'tab4':
				return (
					<>
						<div className="mt-5 flex flex-col gap-5">
							<span className="font-bold text-sm">
								{t('Shablon Xizmatlar')}
							</span>
							<Table
								columns={columnsShablonServices}
								dataSource={serviceItemsData?.filter(
									(item) =>
										item.u_Modal === 'Templete_Services',
								)}
								rowKey={(record) => record.itemCode}
								onRow={(record) => ({
									// onClick: (e) => {
									// 	e.stopPropagation()
									// 	toggleShablonServiceSelection(
									// 		record?.itemCode,
									// 	)
									// },
								})}
								pagination={false}
							/>
						</div>
						<div className="mt-10 flex flex-col gap-5">
							<span className="font-bold text-sm">
								{t('Shablon Shakllari')}
							</span>
							<Table
								columns={columnsShablonParametrs}
								dataSource={serviceItemsData?.filter(
									(item) =>
										item.u_Modal === 'Templete_Figures',
								)}
								rowKey={(record) => record.itemCode}
								onRow={(record) => ({
									// onClick: (e) => {
									// 	e.stopPropagation()
									// 	toggleShablonParametrSelection(
									// 		record?.itemCode,
									// 	)
									// },
								})}
								pagination={false}
							/>
						</div>
					</>
				)

			case 'tab5':
				return (
					<>
						<Table
							columns={columnsKalitParametrs}
							dataSource={kalitShapedData}
							rowKey={(record) => record.itemCode}
							onRow={(record) => ({
								// onClick: (e) => {
								// 	e.stopPropagation()
								// 	toggleKalitParametrSelection(
								// 		record?.itemCode,
								// 		record?.key,
								// 	)
								// },
							})}
							pagination={false}
						/>
					</>
				)

			case 'tab6':
				return (
					<>
						<Table
							columns={columnsItemsImages}
							dataSource={serviceItemsData?.filter(
								(item) => item.u_Modal === 'Rhombic_Sketches',
							)}
							rowKey={(record) => record.itemCode}
							onRow={(record) => ({
								// onClick: (e) => {
								// 	e.stopPropagation()
								// 	toggleItemsImagesSelection(record?.itemCode)
								// },
							})}
							pagination={false}
						/>
					</>
				)

			case 'tab7':
				return (
					<>
						<Table
							columns={columnsItemsImages}
							dataSource={serviceItemsData?.filter(
								(item) => item.u_Modal === 'Key_Sketches',
							)}
							rowKey={(record) => record.itemCode}
							onRow={(record) => ({
								// onClick: (e) => {
								// 	e.stopPropagation()
								// 	toggleItemsImagesSelection(record?.itemCode)
								// },
							})}
							pagination={false}
						/>
					</>
				)

			case 'tab8':
				return (
					<>
						<Table
							columns={columnsOtgruzka}
							dataSource={serviceItemsData?.filter(
								(item) => item.u_Modal === 'ort',
							)}
							rowKey={(record) => record.itemCode}
							// onRow={(record) => ({
							// 	onClick: (e) => {
							// 		e.stopPropagation()
							// 		toggleServiceSelection(record?.itemCode)
							// 	},
							// })}
							pagination={false}
						/>
					</>
				)

			default:
				return null
		}
	}

	const handleServiceModalYes = () => {
		setIsConfirmServiceModalVisible(false)
		onClose()
	}

	const handleServiceModalNo = () => {
		setIsConfirmServiceModalVisible(false)
	}

	const handleServiceModalCancel = () => {
		setIsConfirmServiceModalVisible(false)
	}
	return (
		<>
			<Modal
				title={
					<div className="flex items-center gap-2">
						<span className="cursor-pointer text-2xl font-bold">
							{t('services')}
						</span>
					</div>
				}
				open={visible}
				onCancel={() => {
					setIsConfirmServiceModalVisible(true)
				}}
				// onOk={handleOkServices}
				footer={null}
				width="65%"
			>
				<div className="w-full">
					<Space style={{ marginBottom: 16 }} className="mt-5 ovew">
						<button
							className={`${
								activeTab === 'tab1'
									? 'text-blue-900 underline underline-offset-8'
									: ''
							} font-semibold `}
							onClick={() => setActiveTab('tab1')}
						>
							{t('Kalit Xizmatlari')}
						</button>
						<button
							className={`${
								activeTab === 'tab2'
									? 'text-blue-900 underline underline-offset-8'
									: ''
							} font-semibold ml-3 `}
							onClick={() => setActiveTab('tab2')}
						>
							{t('Dumaloq Xizmatlari')}
						</button>
						<button
							className={`${
								activeTab === 'tab3'
									? 'text-blue-900 underline underline-offset-8'
									: ''
							} font-semibold ml-3 `}
							onClick={() => setActiveTab('tab3')}
						>
							{t('Rombik Shakllari')}
						</button>
						<button
							className={`${
								activeTab === 'tab4'
									? 'text-blue-900 underline underline-offset-8'
									: ''
							} font-semibold ml-3 `}
							onClick={() => setActiveTab('tab4')}
						>
							{t('Shablon Shakllari')}
						</button>
						<button
							className={`${
								activeTab === 'tab5'
									? 'text-blue-900 underline underline-offset-8'
									: ''
							} font-semibold ml-3 `}
							onClick={() => setActiveTab('tab5')}
						>
							{t('Kalit Shakllari')}
						</button>
						<button
							className={`${
								activeTab === 'tab6'
									? 'text-blue-900 underline underline-offset-8'
									: ''
							} font-semibold ml-3 `}
							onClick={() => setActiveTab('tab6')}
						>
							{t('Rombik Chizmalari')}
						</button>
						<button
							className={`${
								activeTab === 'tab7'
									? 'text-blue-900 underline underline-offset-8'
									: ''
							} font-semibold ml-3 `}
							onClick={() => setActiveTab('tab7')}
						>
							{t('Kalit Chizmalari')}
						</button>
						<button
							className={`${
								activeTab === 'tab8'
									? 'text-blue-900 underline underline-offset-8'
									: ''
							} font-semibold ml-3 `}
							onClick={() => setActiveTab('tab8')}
						>
							{t('Ortish(Отгрузка)')}
						</button>
					</Space>
					<div className="mt-5">{renderContent()}</div>
					<div className="mt-5 flex items-center justify-end  gap-2">
						<Button
							type="danger"
							className="bg-red-600 text-white hover:bg-red-500"
							onClick={() => {
								setIsConfirmServiceModalVisible(true)
							}}
						>
							{t('cancel')}
						</Button>
						<Button
							type="danger"
							className="bg-blue-800 text-white hover:bg-blue-600"
							onClick={handleOkCombined}
						>
							{t('save')}
						</Button>
					</div>
				</div>
			</Modal>
			<ConfirmExitModal
				visible={isConfirmServiceModalVisible}
				handleClickCancel={handleServiceModalCancel}
				handleClickNo={handleServiceModalNo}
				handleClickYes={handleServiceModalYes}
			/>
		</>
	)
}
